import moment from 'moment'
import calendar from 'node-calendar'
import { mapState, mapGetters } from 'vuex'

const EVENTS_TYPES = Object.freeze({
  RDVS: 'RDVS',
  OPTIONS: 'OPTIONS',
  REMINDERS: 'REMINDERS',
  USERS: 'USERS',
  CALENDAR_EVENTS: 'CALENDAR_EVENTS'
})

export default {
  data () {
    return {
      rdvTotal: 0,
      EVENTS_TYPES: EVENTS_TYPES,
      currentMonth: moment(),
      days: [],
      enabledEvents: {
        [EVENTS_TYPES.RDVS]: true,
        [EVENTS_TYPES.OPTIONS]: true,
        [EVENTS_TYPES.REMINDERS]: true,
        [EVENTS_TYPES.USERS]: true,
        [EVENTS_TYPES.CALENDAR_EVENTS]: true
      }
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isSectorManager', 'isManager', 'isSeller', 'currentUserPk']),
    today () {
      return moment()
    },
    prevMonth () {
      return this.currentMonth.subtract(1, 'months')
    },
    nextMonth () {
      return this.currentMonth.add(1, 'months')
    },
    startDate () {
      let d = this.currentMonth.clone().startOf('month').startOf('day')
      d.subtract(5, 'days')
      return d.format('DD/MM/YYYY')
    },
    endDate () {
      let d = this.currentMonth.clone().endOf('month')
      d.add(5, 'days')
      return d.format('DD/MM/YYYY')
    },
    isLoadingAll () {
      return this.isLoadingReminders || this.isLoadingCalendarEvents || this.isLoadingRdvs || this.isLoadingOptions || this.isLoadingAccesses || this.isLoadingUsers
    },
    day () {
      return moment().format('DD')
    },
    month () {
      return moment().format('MM')
    },
    year () {
      return moment().format('YYYY')
    }
  },
  watch: {
    currentMonth (v) {
      this.initMonthCalendar()
      this.loadEvents()
    }
  },
  methods: {
    loadEvents () {
      if (this.enabledEvents[EVENTS_TYPES.RDVS]) {
        this.loadRdvs()
      }
      if (this.enabledEvents[EVENTS_TYPES.REMINDERS]) {
        this.loadReminders()
      }
      if ((this.isAdmin || this.isSectorManager || this.isManager || this.isSeller) && this.enabledEvents[EVENTS_TYPES.OPTIONS]) {
        this.loadOptions()
      }
      if ((this.isAdmin || this.isSectorManager) && this.enabledEvents[EVENTS_TYPES.USERS]) {
        this.loadUsersTrans()
        this.loadUsersGar()
        this.loadUsersRc()
      }
      if (this.enabledEvents[EVENTS_TYPES.CALENDAR_EVENTS]) {
        this.loadCalendarEvents()
      }
    },
    loadUsersTrans () {
      let params = {
        carte_de_transaction_validity_date__gte: this.startDate,
        carte_de_transaction_validity_date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingUsers = true
      this.$api.userService.get(params).then(res => {
        let users = res.data.items
        this.isLoadingUsers = false
        users.forEach(x => {
          let date = moment(x.carte_de_transaction_validity_date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'users' })
        })
      }).catch(() => {
        this.isLoadingUsers = false
      })
    },
    loadUsersGar () {
      let params = {
        garantie_financiere_validity_date__gte: this.startDate,
        garantie_financiere_validity_date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingUsers = true
      this.$api.userService.get(params).then(res => {
        this.isLoadingUsers = false
        let users = res.data.items
        users.forEach(x => {
          let date = moment(x.garantie_financiere_validity_date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'users' })
        })
      }).catch(() => {
        this.isLoadingUsers = false
      })
    },
    loadUsersRc () {
      let params = {
        rc_professionnelle_validity_date__gte: this.startDate,
        rc_professionnelle_validity_date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingUsers = true
      this.$api.userService.get(params).then(res => {
        this.isLoadingUsers = false
        let users = res.data.items
        users.forEach(x => {
          let date = moment(x.rc_professionnelle_validity_date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'users' })
        })
      }).catch(() => {
        this.isLoadingUsers = false
      })
    },
    loadAccesses () {
      let params = {
        end_date__gte: this.startDate,
        end_date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingAccesses = true

      let loadPageAccesses = (page, params) => {
        let pageParams = Object.assign({}, params)
        pageParams.page = page
        this.$api.accessService.get(pageParams).then(res => {
          this.isLoadingAccesses = false
          let accesses = res.data.items
          accesses.forEach(x => {
            let date = moment(x.end_date, 'DD/MM/YYYY')
            let key = date.format('DD/MM/YYYY')
            this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'accesses' })
          })
        }).catch(() => {
          this.isLoadingAccesses = false
        })
      }

      this.$api.accessService.get(params).then(res => {
        const pages = res.data.pages
        for (let p = 1; p <= pages; p++) {
          loadPageAccesses(p, params)
        }
      }).catch(() => {
        this.isLoadingAccesses = false
      })
    },
    loadOptions () {
      let params = {
        status: ['approved', 'waiting_list'],
        end_date__gte: this.startDate,
        end_date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingOptions = true
      this.$api.optionService.get(params).then(res => {
        let options = res.data.items
        options.forEach(x => {
          let date = moment(x.end_date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'options' })
        })
        this.isLoadingOptions = false
      }).catch(() => {
        this.isLoadingOptions = false
      })
    },
    loadRdvs (page = 1) {
      let params = {
        date__gte: this.startDate,
        date__lte: this.endDate,
        per_page: 100,
        page
      }
      this.isLoadingRdvs = true
      this.$api.rdvService.get(params).then(res => {
        let rdvs = res.data.items
        rdvs.forEach(x => {
          let date = moment(x.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'rdvs' })
        })
        this.isLoadingRdvs = false
        if (res.data.page < res.data.pages) {
          this.loadRdvs(++page)
        }
      }).catch(() => {
        this.isLoadingRdvs = false
      })
    },
    loadCalendarEvents () {
      let params = {
        date__gte: this.startDate,
        date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingCalendarEvents = true
      this.$api.calendarEventService.get(params).then(res => {
        this.isLoadingCalendarEvents = false
        let events = res.data.items
        events.forEach(x => {
          let date = moment(x.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'calendarEvents' })
        })
      }).catch(() => {
        this.isLoadingCalendarEvents = false
      })
    },
    loadReminders () {
      let params = {
        end_date__gte: this.startDate,
        end_date__lte: this.endDate,
        per_page: 100
      }
      this.isLoadingReminders = true
      this.$api.reminderService.get(params).then(r => {
        let reminders = r.data.items
        reminders.forEach(x => {
          let date = moment(x.date)
          let key = date.format('DD/MM/YYYY')
          this.$store.commit('addCalendarEvent', { event: x, key: key, type: 'reminders' })
        })
        this.isLoadingReminders = false
      }).catch(() => {
        this.isLoadingReminders = false
      })
    },
    initMonthCalendar () {
      this.rdvTotal = 0
      let days = []
      let cal = new calendar.Calendar(0).itermonthdates(this.currentMonth.year(), this.currentMonth.month() + 1)
      cal.forEach(day => {
        days.push({
          key: moment(day).format('DD/MM/YYYY'),
          date: moment(day)
        })
      })
      this.days = days
    },
    goToNextMonth () {
      if (this.isLoadingAll) return
      let d = this.currentMonth.clone()
      d.add(1, 'months')
      this.$set(this, 'currentMonth', d.clone())
      // this.currentMonth = d.clone()
    },
    goToPrevMonth () {
      if (this.isLoadingAll) return
      let d = this.currentMonth.clone()
      d.subtract(1, 'months')
      this.$set(this, 'currentMonth', d.clone())
      // this.currentMonth = d.clone()
    },
    goToCurrentMonth () {
      if (this.isLoadingAll) return
      this.currentMonth = this.today.clone()
    },
    goToMonth (val, dateStr, instance) {
      console.log(instance)
      let d = this.currentMonth.clone()
      let comparator = Number(`${instance.currentYear}${instance.currentMonth < 10 ? `0${instance.currentMonth}` : instance.currentMonth}`)
      if (d.format('YYYYMM') - 1 < comparator) {
        d.add(1, 'months')
      } else if (d.format('YYYYMM') - 1 > comparator) {
        d.subtract(1, 'months')
      } else {
        d = this.today.clone()
      }
      this.fromUser = false
      this.currentMonth = d.clone()
      this.$nextTick(() => {
        this.fromUser = true
      })
    },
    goToMonthLeft () {
      let d = this.currentMonth.clone()
      d.subtract(1, 'months')
      this.fromUser = false
      this.currentMonth = d.clone()
      this.$nextTick(() => {
        this.fromUser = true
      })
    },
    goToMonthRight () {
      let d = this.currentMonth.clone()
      d.add(1, 'months')
      this.fromUser = false
      this.currentMonth = d.clone()
      this.$nextTick(() => {
        this.fromUser = true
      })
    },
    goToYear (val, dateStr, instance) {
      let d = this.currentMonth.clone()
      let comparator = Number(`${instance.currentYear}${instance.currentMonth < 10 ? `0${instance.currentMonth}` : instance.currentMonth}`)
      if (d.format('YYYYMM') - 1 < comparator) {
        d.add(1, 'year')
      } else if (d.format('YYYYMM') - 1 > comparator) {
        d.subtract(1, 'year')
      } else {
        d = this.today.clone()
      }
      this.fromUser = false
      this.currentMonth = d.clone()
      this.$nextTick(() => {
        this.fromUser = true
      })
    }
  },
  created () {
    this.currentMonth = this.today.clone()
    this.initMonthCalendar()
    this.loadEvents()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CalendarMixin.js